import * as React from 'react';

function SvgMyContest(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
      <defs>
        <clipPath id="my_contest_svg__clip-path">
          <path
            id="my_contest_svg__Rectangle_372"
            d="M0 0h24v24H0z"
            className="my_contest_svg__cls-1"
            data-name="Rectangle 372"
            transform="translate(222 620)"
          />
        </clipPath>
        <style>{`.my_contest_svg__cls-1{fill:${props.fill}`}</style>
      </defs>
      <g
        id="my_contest_svg__my_contest"
        transform="translate(-222 -620)"
        clipPath="url(#my_contest_svg__clip-path)"
      >
        <g
          id="my_contest_svg__Group_227"
          data-name="Group 227"
          transform="translate(160.504 511.085)"
        >
          <g
            id="my_contest_svg__Group_226"
            data-name="Group 226"
            transform="translate(62.833 122.695)"
          >
            <path
              id="my_contest_svg__Path_269"
              d="M93.566 134.437l-2.732-2.737v.939l-.285.483 1.722 1.722-2 .771a.8.8 0 00-.46.46l-.771 2-.613-.613-.853.853 1.056 1.056a.8.8 0 001.312-.278l.931-2.42 2.42-.931a.8.8 0 00.278-1.312z"
              className="my_contest_svg__cls-1"
              data-name="Path 269"
              transform="translate(-72.995 -131.513)"
            />
            <path
              id="my_contest_svg__Path_270"
              d="M70.119 135.881l-.186-.267-2.333 2.334-.771-2a.8.8 0 00-.459-.46l-2-.771 1.936-1.936a1.938 1.938 0 01-.212-.415c0-.051-.047-.507-.1-.983l-2.926 2.917a.8.8 0 00.279 1.312l2.42.93.931 2.421a.8.8 0 001.312.278l3.159-3.159z"
              className="my_contest_svg__cls-1"
              data-name="Path 270"
              transform="translate(-62.833 -131.38)"
            />
          </g>
          <path
            id="my_contest_svg__Path_271"
            d="M76.372 128.3a3.446 3.446 0 01-1.464-.464 2.794 2.794 0 00-.987-.355 2.8 2.8 0 00-.987.355 3.444 3.444 0 01-1.463.464 1.5 1.5 0 01-.461-.071 2.653 2.653 0 01-1.361-1.486 2.734 2.734 0 00-.556-.83 2.743 2.743 0 00-.974-.278 2.025 2.025 0 01-2.046-2.8 2.772 2.772 0 00.034-1.026 2.694 2.694 0 00-.606-.767 2.07 2.07 0 010-3.545 2.678 2.678 0 00.606-.767 2.769 2.769 0 00-.034-1.026 2.025 2.025 0 012.046-2.8 2.744 2.744 0 00.974-.278 2.731 2.731 0 00.555-.83 2.654 2.654 0 011.362-1.486 1.5 1.5 0 01.461-.071 3.443 3.443 0 011.463.464 2.793 2.793 0 00.987.355 2.785 2.785 0 00.987-.355 3.446 3.446 0 011.463-.464 1.5 1.5 0 01.462.071 2.655 2.655 0 011.361 1.486 1.46 1.46 0 001.53 1.108 2.025 2.025 0 012.046 2.8 2.757 2.757 0 00-.034 1.026 2.678 2.678 0 00.606.767 2.07 2.07 0 010 3.545 2.694 2.694 0 00-.606.767 2.76 2.76 0 00.034 1.026 2.025 2.025 0 01-2.046 2.8 1.461 1.461 0 00-1.53 1.109 2.653 2.653 0 01-1.361 1.486 1.5 1.5 0 01-.461.07zm-2.45-2.026a3.536 3.536 0 011.516.477 2.742 2.742 0 00.934.342.284.284 0 00.089-.012c.231-.075.463-.514.667-.9a2.553 2.553 0 012.389-1.734c.428-.075.913-.16 1.051-.35a2.023 2.023 0 00.008-1.1 3.5 3.5 0 01.013-1.567 3.385 3.385 0 01.889-1.236c.309-.317.659-.677.659-.931s-.35-.613-.659-.93a3.385 3.385 0 01-.889-1.236 3.5 3.5 0 01-.013-1.567 2.023 2.023 0 00-.008-1.1c-.138-.19-.623-.275-1.051-.35a2.553 2.553 0 01-2.389-1.734c-.2-.388-.436-.827-.667-.9a.285.285 0 00-.089-.012 2.742 2.742 0 00-.934.342 2.646 2.646 0 01-3.032 0 2.738 2.738 0 00-.934-.342.287.287 0 00-.089.012c-.23.075-.462.514-.666.9a2.555 2.555 0 01-2.389 1.734c-.428.075-.913.16-1.052.35s-.067.669-.007 1.1a3.5 3.5 0 01-.013 1.567 3.385 3.385 0 01-.889 1.236c-.309.317-.659.676-.659.931s.35.613.659.93a3.39 3.39 0 01.889 1.236 3.5 3.5 0 01.012 1.57c-.06.427-.128.91.008 1.1s.623.275 1.051.35a2.555 2.555 0 012.389 1.734c.2.388.436.827.666.9a.287.287 0 00.089.012 2.737 2.737 0 00.934-.342 3.538 3.538 0 011.516-.477z"
            className="my_contest_svg__cls-1"
            data-name="Path 271"
            transform="translate(-.685)"
          />
          <path
            id="my_contest_svg__Path_272"
            d="M76.7 127.211a5.431 5.431 0 010-10.861 5.429 5.429 0 015.43 5.43 5.437 5.437 0 01-5.43 5.431zm0-9.654a4.223 4.223 0 102.579.879 4.183 4.183 0 00-2.579-.879z"
            className="my_contest_svg__cls-1"
            data-name="Path 272"
            transform="translate(-3.467 -2.511)"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgMyContest;
